import { serializeSelectAccountQueryParams } from '@/routes/SelectAccountRoute'
import { useCurrentUser } from '@joyful/ui/app'
import { Navigate } from 'react-router-dom'
import { addOrganizationScopeToPath } from '@/features/auth/utils/addOrganizationScopeToPath'
import { useRouterOrgSlugFor } from '@/features/auth/hooks/useRouterOrgSlug'
export interface OrgSelectionRedirectProps {
  targetPath: string
}
export function OrgSelectionRedirect({
  targetPath,
}: OrgSelectionRedirectProps) {
  const currentUser = useCurrentUser()
  const firstAccountSlug = currentUser.accounts[0]?.slug ?? null
  const firstAccountUrlSlug = useRouterOrgSlugFor(firstAccountSlug)

  if (currentUser.accounts.length === 1 && firstAccountUrlSlug !== null) {
    const scopedTargetPath = addOrganizationScopeToPath({
      orgSlug: firstAccountUrlSlug,
      path: targetPath,
    })

    return <Navigate to={scopedTargetPath} replace />
  }

  return (
    <Navigate
      to={serializeSelectAccountQueryParams(`/select-account`, {
        redirect: targetPath,
      })}
      replace
    />
  )
}
